import service from '@/services/departament/DepartamentService'

export const departamentModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    departamentList: [],
    departament: {},
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
    headerList: [],
  },
  mutations: {
    SET_DEPARTAMENT_LIST(state, payload) {
      if (payload.current_page) {
        state.pagination.current_page = payload.current_page
        state.pagination.last_page = payload.last_page
      }
      state.departamentList = payload.data ?? payload
    },
    SET_DEPARTAMENT(state, payload) {
      state.departament = payload
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },

  actions: {
    async getDepartaments({ commit }, payload) {
      try {
        commit('SET_LOADING')
        const response = await service.getDepartaments(payload)
        commit('SET_DEPARTAMENT_LIST', response)
        return response
      } finally {
        commit('SET_LOADING')
      }
    },
    async getDepartament({ commit }, payload) {
      try {
        commit('SET_LOADING')
        const response = await service.getDepartament(payload)
        commit('SET_DEPARTAMENT', response)
        return response
      } finally {
        commit('SET_LOADING')
      }
    },
    async updateDepartament({ commit, dispatch, state }, payload) {
      try {
        commit('SET_LOADING')
        const form = { ...payload.form }
        const { status } = await service.update(form, payload.id)
        dispatch('getDepartaments', { page: state.pagination.current_page })

        return status
      } finally {
        commit('SET_LOADING')
      }
    },
    async insertDepartament({ commit, dispatch, state }, payload) {
      try {
        commit('SET_LOADING')
        const { status } = await service.insert(payload)

        dispatch('getDepartaments', { page: state.pagination.current_page })

        return status
      } finally {
        commit('SET_LOADING')
      }
    },
    async deleteDepartament({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)
      dispatch('getDepartaments', { page: state.pagination.current_page })
      return status
    },

    /* Obtém um código do departamento ao incluir novo departamento */
    async createDepartament() {
      const retorno = await service.createDepartament()
      return retorno
    },
  },
  getters: {
    getComboBoxListDeps: (state) => {
      let comboBox = state.departamentList.map((dep) => {
        return {
          CODIGO: dep.CODIGO,
          DESCRICAO: dep.CODIGO + ' - ' + dep.DESCRICAO,
        }
      })
      return comboBox
    },
  },
}
